import React, {useState} from 'react'
import PropTypes from 'prop-types'
import UploadWall from '../../../upload/UploadWall'
import moment from 'moment'
import { message, Modal } from 'antd'
import { delResource } from '../../../../actions/interview'
import * as Actions from "../../../../actions/taskUpload"
//import {PIC_TYPE} from "../../../constants/index";
import { useEffect } from 'react';
import PDF from '../../../major-projects/images/PDF.png'
import RAR from '../../../major-projects/images/RAR.png'
import TXT from '../../../major-projects/images/TXT.png'
import WORD from '../../../major-projects/images/Word.png'
import XLXS from '../../../major-projects/images/XLXS.png'


function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}
const UploadItem = (props) => {

    const [previewVisible, setPreviewVisible] =  useState(false)
    const [previewImage, setPreviewImage] = useState('')
    const [fileList, setFileList] = useState(props.fileList ? props.fileList : [])

    useEffect(() => {
        let fileList = [];
        //判断 props.title 
        if (props.fileType === '附件') {
            //对fileList的每一项url进行处理
            if (props.fileList && props.fileList.length > 0) {
                for (let i = 0; i < props.fileList.length; i++) {
                    fileList.push({
                        resourceId: props.fileList[i].resourceId,
                        uid: parseInt(props.fileList[i].id) * -1,
                        name: props.fileList[i].name,
                        status: 'done',
                        url: props.fileList[i].path,
                        ext: props.fileList[i].ext,
                        downloadUrl: props.fileList[i].path,
                        taskMenuId: props.fileList[i].taskMenuId && props.fileList[i].taskMenuId,
                        title: props.fileList[i].resourceUrl && props.fileList[i].resourceUrl
                    })
                }
            }
        } 
        if(props.fileType === '视频'){
            if (props.fileList && props.fileList.length > 0) {
                props.fileList.map((item) => (
                    fileList.push({
                        resourceId: item.resourceId,
                        uid: parseInt(item.id) * -1,
                        name: item.name,
                        status: 'done',
                        //url:item.path,
                        url: item.path + "/thumbnails/1",
                        downloadUrl: item.path,
                        taskMenuId: item.taskMenuId && item.taskMenuId,
                        title: item.resourceUrl && item.resourceUrl
                        //url: `${item.path}?s=${Math.random()}`,

                    })
                ))
            }

        }
        if(props.fileType === '图片') {
            if (props.fileList && props.fileList.length > 0) {
                props.fileList.map((item) => (
                    fileList.push({
                        resourceId: item.resourceId,
                        uid: parseInt(item.id) * -1,
                        name: item.name,
                        status: 'done',
                        url:item.path,
                        downloadUrl: item.path,
                        taskMenuId: item.taskMenuId && item.taskMenuId,
                        title: item.resourceUrl && item.resourceUrl
                    })
                ))
            }
        }
        setFileList(fileList)
    }, [props.fileList])



    const  handlePreview = async file => {
        if (props.fileType !== "视频"){
            if (!file.url && !file.preview) {
                file.preview = await getBase64(file.originFileObj);
            }
        }
        setPreviewImage(file.downloadUrl);
        setPreviewVisible(true)
    };

    const handleChange = ({ file, fileList }) => {
        if(file.status === "done"){
            let newFileList = fileList.map(item=>{
                return item;
            });
            setFileList(newFileList)
        }
    };

    console.log(fileList)

    const  handleRemove = async file => {
      const resourceType = {
          '图片' : 2,
          '视频' : 3,
          '附件' : 4
      } 
      if(props.status === 3){
          message.error('当前任务已提交，不可删除！');
          return;
      }
      console.log(file)
      let params = { taskMenuId: file.taskMenuId, resourceId: file.resourceId , type: resourceType[props.fileType], taskId:  props.taskId };
      Actions.delResource(params,(res) => {
        let newFileList = fileList.filter((item) => {
            return item.uid !== file.uid
        });
        setFileList(newFileList)
    })
    };

    const handleDownload = (file) => {
        let url = file.downloadUrl
        if(url.indexOf("?") === -1){
            window.location.href = url + "?download=1";
        }else{
            window.location.href = url + "&download=1";
        }
    }

    const handleCancel = () => {
        setPreviewVisible(false)
    }

    const { fileType, uploadBtnName, showIcon } = props;
   return(
       <>
        <UploadWall
                            //accept={"."+PIC_TYPE.join(",.")}
                            multiple={true}
                            action="/cm-sites-pms/index/uploadFile"
                            listType="picture-card"
                            fileList={fileList}
                            icons={showIcon}
                            uploadBtnName={uploadBtnName}
                            onDownload={handleDownload}
                            onPreview={handlePreview}
                            onChange={handleChange}
                            onRemove={handleRemove}
                            showUploadBtn={false}
                            onPlay={handlePreview}
                            //fileType={fileType}
                        />
                        <Modal visible={previewVisible} footer={null} onCancel={handleCancel}>
                            <div style={{margin:"15px",maxWidth:"900px",maxHeight:"600px", overflow:"auto", position:"relative"}}>
                                {
                                    fileType === '视频' ? <video controls autoPlay  style={{ width: '100%'}} src={previewImage} /> :<img alt="example" style={{ width: '100%' }} src={previewImage} />
                                }
                                
                            </div>
                        </Modal></>
   ) 
}


export default UploadItem